module.exports = __webpack_public_path__ + "img/dog.800685fb.jpeg";